import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import Modal from '@components/primitives/Modal/index.client'
import { classMerge } from '@components/utilities/classMerge'
import { type TrialAssociation } from '@modules/trials/types/TrialAssociation'
import type { ImageCategory } from '@prisma/client'
import { useState } from 'react'

import { getAltTextForTrialImage } from './helpers'
import { TrialMediaLibraryDescription } from './TrialMediaLibraryDescription'

type Image = { category: ImageCategory; externalId: string }

export const MediaLibraryImage = ({
  image,
  trial,
}: {
  image: Image
  trial: TrialAssociation
}) => {
  const alt = getAltTextForTrialImage(image.category, trial)

  const [modalVisible, setModalVisible] = useState(false)

  const isWideImage = ['TrialEligibility', 'TrialPatientQuotes'].includes(
    image.category,
  )

  const cardColumnSpan = isWideImage ? 'md:col-span-2' : 'md:col-span-1'
  const imageCardClasses = isWideImage ? 'pt-6 items-end' : 'py-6 items-center'
  const imageWrapperClasses = isWideImage ? 'rounded-t-2xl' : 'rounded-2xl'

  return (
    <div
      className={classMerge(
        'flex justify-center rounded-2xl border border-neutral200 bg-neutral100 px-6',
        imageCardClasses,
        cardColumnSpan,
      )}
    >
      <div
        className={classMerge(
          'cursor-pointer bg-white px-3 pt-6 text-center',
          imageWrapperClasses,
        )}
        onClick={() => {
          setModalVisible(true)
        }}
      >
        <div className='relative overflow-hidden'>
          <CloudflareImage
            alt={alt}
            className='inset-x-0 bottom-0 mx-auto translate-y-7'
            fit='fill'
            imageId={image.externalId}
          />
        </div>
        <Modal
          onClose={() => setModalVisible(false)}
          size='Large'
          visible={modalVisible}
        >
          <div className='mt-4 text-left'>
            <div className='flex w-full justify-center overflow-hidden'>
              <CloudflareImage
                alt={alt}
                className='mb-[-10%]'
                fit='fill'
                imageId={image.externalId}
              />
            </div>
            <div className='flex justify-center px-4 pt-4'>
              <TrialMediaLibraryDescription
                category={image.category}
                trial={trial}
              />
            </div>
          </div>
        </Modal>
      </div>
    </div>
  )
}
